module.exports = __webpack_public_path__ + "img/game-icons_money-stack.df703a32.png";